import { useState } from 'react';
import useIsEditMode from '../../../hooks/useIsEditMode';

export const DEFAULT_ORDER_SETTINGS = {
  availableStock: '1000',
  limitPerOrder: '1000',
  minimumPerOrder: '1',
};

export default function useOrderSettings({
  values: externalValues,
  onChange,
  onReset,
  orderCount = 0,
} = {}) {
  const isEditMode = useIsEditMode();
  const [internalValues, setInternalValues] = useState(DEFAULT_ORDER_SETTINGS);
  const [isHidden, setIsHidden] = useState(false);

  const currentValues = externalValues || internalValues;

  const handleFieldChange = (field, value) => {
    const updated = { ...currentValues, [field]: value };
    setInternalValues(updated);
    if (onChange) {
      onChange(updated);
    }
  };

  const handleReset = () => {
    setInternalValues(DEFAULT_ORDER_SETTINGS);
    if (onReset) {
      onReset(DEFAULT_ORDER_SETTINGS);
    }
    if (onChange) {
      onChange(DEFAULT_ORDER_SETTINGS);
    }
  };

  const toggleHidden = () => {
    setIsHidden((prev) => !prev);
  };

  const validationErrors = {};
  const isStockEmpty =
    currentValues.availableStock === '' ||
    currentValues.availableStock === null ||
    currentValues.availableStock === undefined;
  const isLimitEmpty =
    currentValues.limitPerOrder === '' ||
    currentValues.limitPerOrder === null ||
    currentValues.limitPerOrder === undefined;

  const stockVal = isStockEmpty ? NaN : Number(currentValues.availableStock);
  const limitVal = isLimitEmpty ? NaN : Number(currentValues.limitPerOrder);
  const countVal = Number(orderCount || 0);

  if (isStockEmpty || isNaN(stockVal) || stockVal <= 0) {
    validationErrors.availableStock = 'Available stock must be greater than 0';
  } else if (countVal > 0 && stockVal < countVal) {
    validationErrors.availableStock = `Available stock cannot be less than current order count (${countVal})`;
  }

  if (
    !isLimitEmpty &&
    !isStockEmpty &&
    !isNaN(limitVal) &&
    !isNaN(stockVal) &&
    limitVal > stockVal
  ) {
    validationErrors.limitPerOrder = 'Limit per order cannot exceed available stock';
  }

  return {
    values: currentValues,
    setValues: setInternalValues,
    isHidden,
    setIsHidden,
    toggleHidden,
    handleFieldChange,
    handleReset,
    isEditMode,
    validationErrors,
  };
}
